import { Meta } from 'aimo-ui';
import Info from 'components/common/Info';
import Icon from 'components/icons/Icon';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';
import { Maybe, SalesOrderStatus } from 'types/generatedSchemaTypes';

const styles = (numberCount: number) =>
  StyleSheet.create({
    icon: {
      fontWeight: 700,
      fontSize: 26,
      position: 'absolute',
      right: 40 + (numberCount > 9 ? -7 : 0),
      top: 17,
      lineHeight: 28,
      letterSpacing: 0,
    },
  });

const Box = styled.View`
  border-radius: 20px;
  background-color: ${(p) => p.theme.colors.lightBg.green};
  padding: 10px;
  margin-bottom: 10px;
`;

const NumberTicket = ({ waitingCount }: { waitingCount: number }) => {
  return (
    <>
      {waitingCount > 99 ? (
        <Icon size="xxl" name="Number-Ticket-Max" />
      ) : (
        <>
          <Icon size={65} name="Number-Ticket" />
          <Meta style={styles(waitingCount).icon}>{waitingCount}</Meta>
        </>
      )}
    </>
  );
};

const WaitingNumber = ({
  waitingCount,
  orderStatus,
  isSalesOrder = false,
}: {
  waitingCount: Maybe<number> | undefined;
  orderStatus: Maybe<SalesOrderStatus> | undefined;
  isSalesOrder?: boolean;
}) => {
  const { t } = useTranslation();
  const waitingApproval = orderStatus === 'WAITING_FOR_CSR_APPROVAL';

  const text = () => {
    if (isSalesOrder) {
      return t('longTermParking.waitingList.waitingApprovalSalesOrder');
    }
    return waitingApproval
      ? t('longTermParking.waitingList.waitingApproval')
      : t('longTermParking.waitingList.info.estimate', {
          count: waitingCount ?? 0,
        });
  };

  return (
    <Box>
      <Info
        icon={
          waitingApproval ? (
            <Icon size="l" name="Info-Outlined" />
          ) : (
            <NumberTicket waitingCount={waitingCount ?? 0} />
          )
        }
        text={text()}
        last
      />
    </Box>
  );
};

export default WaitingNumber;
